import { Directive, ElementRef, HostListener, Renderer2 } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Directive({
  selector: '[appArabicOrEnglishRegOnly]',
  standalone: true
})
export class ArabicOrEnglishRegOnlyDirective {

  constructor(
    private el: ElementRef,
    private renderer: Renderer2,
    private translate: TranslateService,
  ) { }

  @HostListener('input', ['$event'])
  onInput(event: InputEvent): void {
    const inputElement = this.el.nativeElement as HTMLInputElement;
    const currentValue = inputElement.value;

    if (this.translate.currentLang === 'ar') {
      // Allow only Arabic characters
      inputElement.value = currentValue.replace(/[^ء-ي\s]/g, ''); // Arabic range: U+0621 to U+064A
    } else {
      // Allow only English characters
      inputElement.value = currentValue.replace(/[^a-zA-Z\s]/g, ''); // English alphabet and spaces
    }
  }

}
